import { render, staticRenderFns } from "./LabExamsSection.vue?vue&type=template&id=57de9c90&scoped=true&"
import script from "./LabExamsSection.vue?vue&type=script&lang=js&"
export * from "./LabExamsSection.vue?vue&type=script&lang=js&"
import style0 from "./LabExamsSection.vue?vue&type=style&index=0&id=57de9c90&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57de9c90",
  null
  
)

export default component.exports